module.exports = __webpack_public_path__ + "img/demonstration.3c0dcc2c.jpg";